import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const formatSavedAt = (updatedAt) => {
  if (!updatedAt) return '';
  const date = new Date(updatedAt);
  if (Number.isNaN(date.getTime())) return '';
  // Same format as DraftRecoveryModal's "saved at" line, so the toast and the modal the
  // user lands on describe the same draft identically.
  return `Saved ${date.toLocaleString()}`;
};

/**
 * Body of the unfinished-drafts toast. Closing it only stands the reminder down for the page
 * the user is on — the watcher brings it back on the next navigation. Presentational only:
 * the watcher owns the data and the navigation, so this renders from props and is testable
 * without redux, router or IDB.
 */
const DraftListToast = ({ drafts, onOpen, onDismiss, closeToast }) => {
  const count = drafts.length;

  const handleDismiss = () => {
    onDismiss();
    closeToast();
  };

  return (
    <Styled.Wrapper>
      <Styled.CancelButton type="button" onClick={handleDismiss} aria-label="Dismiss unfinished surveys reminder" />
      <Styled.Title>
        {count === 1 ? 'You have 1 unfinished survey' : `You have ${count} unfinished surveys`}
      </Styled.Title>
      <Styled.Subtitle>Pick one up where you left off.</Styled.Subtitle>
      <Styled.List>
        {drafts.map((draft) => (
          <Styled.Item key={draft.key}>
            <Styled.DraftButton type="button" onClick={() => onOpen(draft.url)}>
              <Styled.DraftLabel>{draft.label}</Styled.DraftLabel>
              <Styled.DraftMeta>{formatSavedAt(draft.updatedAt)}</Styled.DraftMeta>
            </Styled.DraftButton>
          </Styled.Item>
        ))}
      </Styled.List>
    </Styled.Wrapper>
  );
};

DraftListToast.propTypes = {
  drafts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      updatedAt: PropTypes.string,
    }),
  ).isRequired,
  onOpen: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  // Injected by react-toastify when the content is given as a render function.
  closeToast: PropTypes.func,
};

DraftListToast.defaultProps = {
  closeToast: () => {},
};

export default DraftListToast;
